var Layout   = require("enyo-ui/Layout"),
    clipText = require("app/utils/clipText"),
    dom      = require("enyo/dom"),
    kind     = require("enyo/kind");

module.exports = kind(/** @lends  app.ui.header.VerticalDescriptionLayout.prototype */ {

    /**
     * @private
     */
    name: "app.ui.header.VerticalDescriptionLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @public
     */
    reflow: function() {
        var $container  = this.container,
            $bodyDrawer = $container.$.bodyDrawer,
            $body       = $container.$.body,
            $readMore   = $container.$.readMore,
            bodyNode,
            lineHeight,
            maxBodyHeight;

        if (!$container.hasNode()) {
            return;
        }

        // Calculate max body height
        bodyNode      = $body.hasNode();
        lineHeight    = parseFloat(dom.getComputedStyleValue(bodyNode, "line-height"), 10);
        maxBodyHeight = 3 * lineHeight;

        // Unclip the body text, we'll clip it later if needed
        clipText.unclip(bodyNode);

        // Show readmore/less toggle if needed
        $readMore.set("showing", bodyNode.scrollHeight > maxBodyHeight);

        // Configure drawer
        $bodyDrawer.set("closedSize", maxBodyHeight);

        if (!$bodyDrawer.isOpen && !$bodyDrawer.willOpen) {
            clipText.clip(bodyNode, maxBodyHeight, true);
        }
    }

});
